import { get } from 'env-var'
interface PropsAdapter {
    online: boolean
    URL_BASE: string
    URL_BASE_AUTH: string
    URL_BASE_REPORTES_PEX: string
    URL_BASE_LOGISTICA: string
    URL_BASE_ATC: string
    WS_HOST: string
    WS_PORT: string
    WS_PATH: string
    PATH_API_FILE: string
    user_API_FILE: string
    WS_SECURE: string
    SISTEMAS_VALORIZACION_MANO_OBRA: string[]
    SISTEMAS_VALORIZACION_MATERIALES: string[]
    MODE: 'prod' | 'dev' | 'local'
    LICENSE_KEY_STRICH: string
}

const MODE: 'prod' | 'dev' | 'local' = process.env.REACT_APP_MODE as 'prod' | 'dev' | 'local' | undefined || 'dev'

const getEnvVariable = (prodVar: string, devVar: string, localVar: string): string => {
    return MODE === 'prod'
        ? process.env[prodVar] ?? ''
        : MODE === 'dev'
            ? process.env[devVar] ?? ''
            : process.env[localVar] ?? ''
}

const URL_MASTER: string = getEnvVariable('REACT_APP_URL_MASTER', 'REACT_APP_URL_MASTER_DEV', 'REACT_APP_URL_MASTER_LOCAL') || 'http://localhost:8002'
const URL_BASE_AUTH: string = getEnvVariable('REACT_APP_URL_MASTER_AUTH', 'REACT_APP_URL_MASTER_AUTH_DEV', 'REACT_APP_URL_MASTER_AUTH_LOCAL') || 'http://localhost:8002'
const URL_BASE_LOGISTICA: string = getEnvVariable('REACT_APP_URL_MASTER_LOGISTICA', 'REACT_APP_URL_MASTER_LOGISTICA_DEV', 'REACT_APP_URL_MASTER_LOGISTICA_LOCAL') || 'http://localhost:8002'
const URL_BASE_REPORTES_PEX: string = getEnvVariable('REACT_APP_URL_MASTER_REPORTES_PEX', 'REACT_APP_URL_MASTER_REPORTES_PEX_DEV', 'REACT_APP_URL_MASTER_REPORTES_PEX_LOCAL') || 'http://localhost:8002'
const URL_BASE_ATC: string = getEnvVariable('REACT_APP_URL_MASTER_ATC', 'REACT_APP_URL_MASTER_ATC_DEV', 'REACT_APP_URL_MASTER_ATC_LOCAL') || 'http://localhost:8002'
const URL_BASE: string = `${URL_MASTER}${MODE === 'prod' ? '/api/SIGO' : '/api/SIGO'}`

const WS_HOST: string = getEnvVariable('REACT_APP_WS_HOST', 'REACT_APP_WS_HOST_DEV', 'REACT_APP_WS_HOST_LOCAL')
const WS_PORT: string = getEnvVariable('REACT_APP_WS_PORT', 'REACT_APP_WS_PORT_DEV', 'REACT_APP_WS_PORT_LOCAL')
const WS_PATH: string = getEnvVariable('REACT_APP_WS_PATH', 'REACT_APP_WS_PATH_DEV', 'REACT_APP_WS_PATH_LOCAL')
const WS_SECURE: string = getEnvVariable('REACT_APP_WS_SECURE', 'REACT_APP_WS_SECURE_DEV', 'REACT_APP_WS_SECURE_LOCAL')

const PATH_API_FILE: string = getEnvVariable('REACT_APP_PATH_API_FILE', 'REACT_APP_PATH_API_FILE_DEV', 'REACT_APP_PATH_API_FILE_LOCAL')
const user_API_FILE: string = getEnvVariable('REACT_APP_user_API_FILE', 'REACT_APP_user_API_FILE_DEV', 'REACT_APP_user_API_FILE_LOCAL')

const SISTEMAS_VALORIZACION_MATERIALES: string[] = get('REACT_APP_SISTEMAS_VALORIZACION_MATERIALES').asArray() || []
const SISTEMAS_VALORIZACION_MANO_OBRA: string[] = get('REACT_APP_SISTEMAS_VALORIZACION_MANO_OBRA').asArray() || []
const LICENSE_KEY_STRICH = get('REACT_APP_LICENSE_KEY_STRICH').asString() || ''

export const AdapterConfigureGenerico: PropsAdapter = {
    online: navigator.onLine,
    URL_BASE,
    URL_BASE_AUTH,
    URL_BASE_LOGISTICA,
    URL_BASE_ATC,
    WS_HOST,
    WS_PORT,
    WS_PATH,
    PATH_API_FILE,
    user_API_FILE,
    WS_SECURE,
    SISTEMAS_VALORIZACION_MANO_OBRA,
    SISTEMAS_VALORIZACION_MATERIALES,
    URL_BASE_REPORTES_PEX,
    MODE,
    LICENSE_KEY_STRICH
}
